<template>
	<ViewFeedItem class="view-feed-fact">
		<!-- <template v-slot:header>
			<ViewLayoutModuleHeader title="Cue Knowledge">
				<a href="#" v-on:click="Handle_OnClickRefresh">
					<strong>Refresh</strong>
				</a>
			</ViewLayoutModuleHeader>
		</template> -->

		<template v-slot:body>
			<h3 class="push-bottom">Did you know...</h3>
			<p v-bind:key="factModel.uniqueKey" v-html="factModel.getFact()"></p>
		</template>
	</ViewFeedItem>
</template>

<script lang="ts">
	import * as Config from '@/Config';
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedFact extends ViewBase {
		/**
		 * @return ChalkySticks.Model.Fact
		 */
		@Prop({
			default: () =>
				ChalkySticks.Factory.Fact.model({
					id: 'random',
				}).cache(Config.App.CACHE_GENERAL_TTL),
		})
		public factModel!: ChalkySticks.Model.Fact;

		/**
		 * @return Promise<void>
		 */
		@mounted
		public async refresh(): Promise<void> {
			this.factModel.setId('random').fetch();
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return Promise<void>
		 */
		protected async Handle_OnClickRefresh(venueModel: ChalkySticks.Model.Venue): Promise<void> {
			this.refresh();
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-feed-fact.view-feed-item {
		background-color: var(--chalky-blue);
		padding: 0.5rem 1rem;

		.body {
			background: url('~@/Asset/image/graphic/feed-background-01.jpg') no-repeat center center/cover;
			border-radius: var(--border-radius);
			padding: 1.5rem 1.5rem 2rem 1.5rem;
			text-align: center;
		}
	}
</style>
